export default __webpack_public_path__ + "static/media/3_MonstaWalletMobile_android.8665c821.webp";